import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

const getProcessData = async (modelId, guid, neighbours = true, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/state/single/${guid}?revision=${revision}`);
		const { state } = data;
		return state;
	} catch (error) {
		checkAuthError(error);

		console.error('getProcessData', error);
		throw error;
	}
};
const getIemClassByType = async (modelId, iemclasstype) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/iemclass/type/${iemclasstype}`);
		const { iemClass } = data;
		return iemClass;
	} catch (error) {
		checkAuthError(error);

		console.error('getIemClassByType', error);
		throw error;
	}
};

const checkProcessExist = async (modelId, guid, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/state/exists/${guid}?revision=${revision}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('checkProcessExist', error);
		throw error;
	}
};

const getAllProcessListAttributes = async (modelId, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/state/allListAttributes?revision=${revision}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('getAllProcessListAttributes', error);
		return { listAttributes: [] };
	}
};

const getAllProcessReferenceAttributes = async (modelId, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/state/allReferenceAttributes?revision=${revision}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('getAllProcessReferenceAttributes', error);
		return { referenceAttributes: [] };
	}
};

const getProcessById = async (modelId, id, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/state/byId/?id=${id}&revision=${revision}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('Couldnt get object by id', error);
		return { process: null };
	}
};

export {
	getProcessData,
	getIemClassByType,
	checkProcessExist,
	getAllProcessListAttributes,
	getAllProcessReferenceAttributes,
	getProcessById,
};
